// import React from 'react';
// import styles from '../../assets/scss/Dashboard.module.scss';
// import {
//   FiBox,
//   FiUsers,
//   FiClock,
// } from 'react-icons/fi';
// import { Doughnut } from 'react-chartjs-2';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
// } from 'chart.js';
// import { useNavigate } from 'react-router-dom';
// import dummyProfile from "../../assets/images/Profile.png";
// import { useGetDashboardQuery } from '../../slices/admin/admin';
// import { BaseURL } from '../../lib/api';

// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement
// );

// const LogisticDashboard = () => {
//   const navigate = useNavigate();

//   const { data: apiData, isLoading, isError } = useGetDashboardQuery();

//   console.log("Dashboard API Data:", apiData);

//   if (isLoading) return <div>Loading dashboard...</div>;
//   if (isError) return <div>Failed to load dashboard data.</div>;

//   // ✅ Extract safely
//   const dashboard = apiData?.data || {};

//   const {
//     totalInvoices = 0,
//     invoiceNeedAttention = 0,
//     invitedUserLength = 0,
//     notifications = [],
//     bannerImages = [],
//   } = dashboard;

//   // ✅ Chart setup
//   const orderData = {
//     labels: ['Total Invoices', 'Need Attention', 'Invited Users'],
//     datasets: [
//       {
//         data: [totalInvoices, invoiceNeedAttention, invitedUserLength],
//         backgroundColor: ['#08a045', '#ffcc00', '#dbf3c9'],
//         borderWidth: 0,
//         circumference: 360,
//         rotation: -90,
//         cutout: '60%',
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: true,
//         position: 'left',
//       },
//     },
//   };

//   // ✅ Banner slider config
//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     arrows: false,
//   };

//   return (
//     <div className={styles.dashboard}>
//       {/* Row 1 */}
//       <div className={styles.grid}>
//         {/* Invoice Overview */}
//         <div className={styles.card}>
//           <div className={styles.header}>
//             <h4 className={styles.heading}>Invoice Overview</h4>
//             <span onClick={() => navigate('/dashboard/Invoicetable')}>View all</span>
//           </div>
//           <div className={styles.orderChartWrapper}>
//             <div className={styles.chartContainer}>
//               <Doughnut data={orderData} options={options} />
//             </div>
//           </div>
//         </div>

//         {/* User Stats */}
//         <div className={styles.card}>
//           <div className={styles.header}>
//             <h4 className={styles.heading}>User Stats</h4>
//           </div>
//           <div className={styles.overviewGridsEmployee}>
//             <div className={`${styles.box} ${styles.orange}`}>
//               <FiBox className={styles.icon} />
//               <h3>{totalInvoices}</h3>
//               <p>Total Invoices</p>
//             </div>
//             <div className={`${styles.box} ${styles.purple}`}>
//               <FiUsers className={styles.icon} />
//               <h3>{invitedUserLength}</h3>
//               <p>Invited Users</p>
//             </div>
//           </div>
//         </div>

//         {/* Notifications */}
//         <div className={styles.card}>
//           <div className={styles.header}>
//             <h4 className={styles.heading}>Banner</h4>
//             {/* <span onClick={() => navigate('/dashboard/Notifications')}>View all</span> */}
//           </div>
//           <div >
//             <div className={styles.header}>
//               <h4 className={styles.heading}></h4>
//             </div>
//             <div className={styles.bannerSliderWrapper}>
//               {bannerImages && bannerImages.length > 0 ? (
//                 <Slider {...sliderSettings}>
//                   {bannerImages.map((img, idx) => (
//                     <div key={idx} className={styles.bannerSlide}>
//                       <img
//                         src={`${BaseURL}/${img}`}
//                         alt={`banner-${idx}`}
//                         className={styles.bannerimg}
//                       />
//                     </div>
//                   ))}
//                 </Slider>
//               ) : (
//                 <p>No banner images available</p>
//               )}
//             </div>
//           </div>
//         </div>


//       </div>

//       {/* Row 2 */}
//       <div className={styles.gridsemp}>
//         {/* Banner Slider */}
//         <div className={styles.header}>
//           <h4 className={styles.heading}>Notifications</h4>
//           <span onClick={() => navigate('/dashboard/Notifications')}>View all</span>
//         </div>

//         <div className={styles.notificationsfarmerbanner}>
//           {notifications.length > 0 ? (
//             notifications.slice(0, 10).map((note) => (
//               <div
//                 key={note._id}
//                 className={`${styles.notification} ${note.isRead === false ? styles.unreadNotification : ""
//                   }`}
//               >
//                 <img
//                   src={
//                     note.createdBy?.profile
//                       ? `${BaseURL}/${note.createdBy.profile}`
//                       : dummyProfile
//                   }
//                   alt={note.createdBy?.firstName || "User"}
//                 />
//                 <div>
//                   <p>{note.message}</p>
//                   <span className={note.isRead === false ? styles.redText : ""}>
//                     <FiClock
//                       className={note.isRead === false ? styles.redIcon : ""}
//                     />{" "}
//                     {new Date(note.createdAt).toLocaleString("en-GB")}
//                   </span>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p>No notifications available</p>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default LogisticDashboard;


import React from 'react';
import styles from '../../assets/scss/Dashboard.module.scss';
import {
  FiBox,
  FiUsers,
  FiClock,
} from 'react-icons/fi';
import { Doughnut } from 'react-chartjs-2';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
} from 'chart.js';
import { useNavigate } from 'react-router-dom';
import dummyProfile from "../../assets/images/Profile.png";
import { useGetDashboardQuery } from '../../slices/admin/admin';
import { BaseURL } from '../../lib/api';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement
);

const LogisticDashboard = () => {
  const navigate = useNavigate();

  const { data: apiData, isLoading, isError } = useGetDashboardQuery();

  if (isLoading) return <div>Loading dashboard...</div>;
  if (isError) return <div>Failed to load dashboard data.</div>;

  // ✅ Extract safely
  const dashboard = apiData?.data || {};

  const {
    totalInvoices = 0,
    invoiceNeedAttention = 0,
    invitedUserLength = 0,
    notifications = [],
    bannerImages = [],
  } = dashboard;

  // ✅ Helper: ensure proper image URL
  const getImageUrl = (path) => {
    if (!path || typeof path !== 'string') return dummyProfile;
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    return `${BaseURL}/${path.replace(/^\/+/, '')}`;
  };

  // ✅ Chart setup
  const orderData = {
    labels: ['Total Invoices', 'Need Attention', 'Invited Users'],
    datasets: [
      {
        data: [totalInvoices, invoiceNeedAttention, invitedUserLength],
        backgroundColor: ['#08a045', '#ffcc00', '#dbf3c9'],
        borderWidth: 0,
        circumference: 360,
        rotation: -90,
        cutout: '60%',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'left',
      },
    },
  };

  // ✅ Banner slider config
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
  };

  return (
    <div className={styles.dashboard}>
      {/* Row 1 */}
      <div className={styles.grid}>
        {/* Invoice Overview */}
        <div className={styles.card}>
          <div className={styles.header}>
            <h4 className={styles.heading}>Invoice Overview</h4>
            <span onClick={() => navigate('/dashboard/Invoicetable')}>View all</span>
          </div>
          <div className={styles.orderChartWrapper}>
            <div className={styles.chartContainer}>
              <Doughnut data={orderData} options={options} />
            </div>
          </div>
        </div>

        {/* User Stats */}
        <div className={styles.card}>
          <div className={styles.header}>
            <h4 className={styles.heading}>User Stats</h4>
          </div>
          <div className={styles.overviewGridsEmployee}>
            <div className={`${styles.box} ${styles.orange}`}>
              <FiBox className={styles.icon} />
              <h3>{totalInvoices}</h3>
              <p>Total Invoices</p>
            </div>
            <div className={`${styles.box} ${styles.purple}`}>
              <FiUsers className={styles.icon} />
              <h3>{invitedUserLength}</h3>
              <p>Invited Users</p>
            </div>
          </div>
        </div>

        {/* Banner */}
        <div className={styles.bannerCard}>
          <div className={styles.header}>
            <h4 className={styles.heading}>Banner</h4>
          </div>
          <div className={styles.bannerSliderWrapper}>
            {bannerImages && bannerImages.length > 0 ? (
              <Slider {...sliderSettings}>
                {bannerImages.map((img, idx) => (
                  <div key={idx} className={styles.bannerSlide}>
                    <img
                      src={getImageUrl(img)}
                      alt={`banner-${idx}`}
                      className={styles.bannerimg}
                      onError={(e) => (e.target.src = dummyProfile)}
                    />
                  </div>
                ))}
              </Slider>
            ) : (
              <p>No banner images available</p>
            )}
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className={styles.gridsemp}>
        <div className={styles.header}>
          <h4 className={styles.heading}>Notifications</h4>
          <span onClick={() => navigate('/dashboard/Notifications')}>View all</span>
        </div>

        <div className={styles.notificationsfarmerbanner}>
          {notifications.length > 0 ? (
            notifications.slice(0, 10).map((note) => (
              <div
                key={note._id}
                className={`${styles.notification} ${note.isRead === false ? styles.unreadNotification : ""}`}
              >
                <img
                  src={getImageUrl(note.createdBy?.profile)}
                  alt={note.createdBy?.firstName || "User"}
                  onError={(e) => (e.target.src = dummyProfile)}
                />
                <div>
                  <p>{note.message}</p>
                  <span className={note.isRead === false ? styles.redText : ""}>
                    <FiClock className={note.isRead === false ? styles.redIcon : ""} />{" "}
                    {new Date(note.createdAt || Date.now()).toLocaleString("en-GB")}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p>No notifications available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogisticDashboard;
